import { esc } from '@/utils/escape';

export function generateProcessHTML(data: any, settings: any): string {
  const steps = (data.steps || [])
    .map(
      (s: any, i: number) => `
      <div class="process__card">
        <div class="process__num">${esc(s.num || String(i + 1).padStart(2, "0"))}</div>
        <div class="process__title">${esc(s.title || "")}</div>
        <div class="process__text">${esc(s.text || "")}</div>
      </div>
  `,
    )
    .join("\n");

  return `  <!-- Process -->
  <section class="process" id="ablauf">
    <div class="container">
      <div class="section-header">
        <h2>${esc(data.title || "")}</h2>
        <p>${esc(data.subtitle || "")}</p>
      </div>
      <div class="process__grid">
${steps}
      </div>
    </div>
  </section>`;
}
